export default "__VITE_ASSET__DYtZ51LX__"